import { Timestamp } from '@bufbuild/protobuf/wkt';
import { DeviceState } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/device_state_pb';
import {
  Device_FirmwareUpdateStatus,
  Device_Status,
} from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/device_pb';

export class DeviceStateModel {
  readonly deviceName: string;

  readonly serialNumber: string;

  readonly registrationKey: string;

  readonly firmwareInstalled: string;

  readonly uptimeSeconds: bigint;

  readonly heartbeatLatencyMs: bigint;

  readonly heartbeatTimestamp?: Timestamp;

  readonly clientLastConnectTime?: Timestamp;

  readonly status: Device_Status;

  readonly firmwareUpdateStatus: Device_FirmwareUpdateStatus;

  constructor(deviceState: DeviceState) {
    this.deviceName = deviceState.deviceName;
    this.serialNumber = deviceState.serialNumber;
    this.registrationKey = deviceState.registrationKey;
    this.firmwareInstalled = deviceState.firmwareInstalled;
    this.uptimeSeconds = deviceState.uptimeSeconds;
    this.heartbeatLatencyMs = deviceState.heartbeatLatencyMs;
    this.heartbeatTimestamp = deviceState.heartbeatTimestamp;
    this.clientLastConnectTime = deviceState.clientLastConnectTime;
    this.status = deviceState.status;
    this.firmwareUpdateStatus = deviceState.firmwareUpdateStatus;
  }
}
